import { useEffect } from 'react';
import { useQuery } from 'react-query';
import isEqual from 'lodash/isEqual';
import { getJob } from 'api/services/jobs';
import { auth, useAuthState } from 'api/services/firebase';
import { isJobInProgress } from 'utils/helpers';
import useJobStore from '../store/jobStore';
import { getSampleJob } from './useRunABJob';

const useGetJob = (jobId) => {
  const [user] = useAuthState(auth);
  const isUserAvailable = !!user;
  const isSampleJob = jobId === 'GX3WjL3ZghA0564B';
  const sampleJob = getSampleJob();

  const details = useJobStore((state) => state.job.details);
  const jobError = useJobStore((state) => state.job.error);
  const setJob = useJobStore((state) => state.setJob);

  const isJobFetchEnabled = (isUserAvailable
    && !isSampleJob
    && (jobId !== details?.jobId || isJobInProgress(details?.runStatus))
  );

  const { data = {}, isLoading, error } = useQuery({
    queryKey: `job_${jobId}`,
    queryFn: getJob(jobId),
    refetchOnMount: false,
    refetchOnWindowFocus: true,
    refetchIntervalInBackground: isJobFetchEnabled,
    refetchInterval: 3000,
    enabled: jobId && isJobFetchEnabled && !jobError,
  });

  const job = isSampleJob ? sampleJob : data;

  useEffect(() => {
    if (!isEqual(details, job) || !isEqual(jobError, error)) {
      setJob(job, isLoading, error);
    }
  }, [job, jobError, details, isLoading, sampleJob, error, setJob]);
};

export default useGetJob;
